import React from "react";
import dataLakeImg from "../images/metabetta_data_lake.png";

export default function About() {
  return (
    <section id="about" className="max-w-screen-xl mx-auto py-10 md:py-12 px-6">
      <div className="flex flex-col md:flex-row justify-between gap-12">
        {/* Image */}
        <div className="md:w-5/12 flex-shrink-0 h-80 md:h-auto">
          <div
            className="w-full h-full min-h-[300px] rounded bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url(${dataLakeImg})` }}
          />
        </div>

        {/* Text */}
        <div className="md:w-7/12 lg:py-8 text-center md:text-left">
          <p className="text-primary-500 font-bold text-sm uppercase tracking-widest">About Metabetta</p>
          <h2 className="mt-4 font-black text-3xl sm:text-4xl lg:text-5xl leading-tight">
            We understand technology <span className="text-primary-500">and</span> business.
          </h2>
          <p className="mt-4 text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100">
            With significant experience with all aspects of digital business, Metabetta can give you a 360 degree view
            of what's important - from budgeting to customer acquisition to technical innovation. Metabetta is the
            consultancy of Phil Morgan, an experienced technologist based in Sydney, Australia. Phil is an AWS Certified
            Cloud Practitioner with a Master's degree in Commerce and many areas of specialty. An expert in AWS
            solutions, Compliance and GDPR, Financial Modelling, PostgreSQL, React, Node, Mongo, Dev Ops and music
            metadata (particularly DDEX ERN & CWR), Phil can help your business with a complete view of any potential
            project or solution. When you engage Metabetta, you know you're talking to the person that can do the work
            and find you the solution you need. Contact us at info@metabetta.com !
          </p>
          <a
            href="#contact"
            className="inline-block mt-8 md:mt-10 px-8 py-3 bg-primary-500 text-white text-sm font-bold rounded hover:bg-primary-700 transition"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
